import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { style: {"margin":"-36px -21px -63px -18px"} }
const _hoisted_4 = { style: {"margin":"35px auto"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30\"><div class=\"\"><h3 class=\"mb-0\">Emergency Room Visits</h3><p>ER based on patient visits</p></div><select class=\"form-select month-select form-control w-135\" aria-label=\"Default select example\"><option selected>Last Week</option><option value=\"1\">Last 60 Days</option><option value=\"2\">Last 90 Days</option></select></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "heatmap",
                height: "235",
                options: _ctx.overallVisitors,
                series: _ctx.visitors
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}